"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinksGroup = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _Tooltip = require("b2b-components/theme/components/Tooltip");
var _classnames = _interopRequireDefault(require("classnames"));
require("./LinksGroup.scss");
var LinksGroup = function LinksGroup(_ref) {
  var position = _ref.position,
    group = _ref.group,
    onClick = _ref.onClick,
    coreAssortmentTooltipText = _ref.coreAssortmentTooltipText,
    className = _ref.className;
  var title = group.title,
    href = group.href,
    children = group.children;
  var handleClick = function handleClick(link, position) {
    return function (e) {
      e.preventDefault();
      onClick(link, position);
    };
  };
  var rootClassName = (0, _classnames["default"])('cds-FlyoutLinksGroup', {
    'cds-FlyoutLinksGroup--Labeled': title
  }, className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: href,
    onClick: handleClick(group, position),
    className: children ? 'cds-FlyoutLinksGroup-Heading' : 'cds-FlyoutLinksGroup-ListItemLink'
  }, title), Array.isArray(children) && /*#__PURE__*/_react["default"].createElement("ul", {
    className: "cds-FlyoutLinksGroup-List"
  }, children.map(function (link, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: "cds-FlyoutLinksGroup-ListItem",
      key: link.title
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: link.href,
      onClick: handleClick(link, index + 1),
      className: "cds-FlyoutLinksGroup-ListItemLink"
    }, link.title, " ", link.hasCoreAssortment && /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, {
      content: coreAssortmentTooltipText,
      wrapperClassName: "cds-FlyoutLinksGroup-Tooltip",
      className: "cds-FlyoutLinksGroup-TooltipContainer"
    }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      name: _Icon.Icon.config.name.coreAssortment,
      size: _Icon.Icon.config.size.small,
      className: "cds-FlyoutLinksGroup-ListItemIcon"
    }))));
  })));
};
exports.LinksGroup = LinksGroup;